/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreditCardRefund = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22.008 4H2v9h2v-1h16.008v6H5.416l1.295-1.292-1.414-1.416L1.585 19l3.712 3.708 1.414-1.416L5.416 20h16.592zm-2 4H4V6h16.008z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCreditCardRefund as CreditCardRefund };
